import { AutoComplete } from "./Suggestions";
import { Box } from "@vinomofo/components";
import Description from "./Description";
import { InstantSearch } from "react-instantsearch-core";
import SearchBox from "./SearchBox";
import algoliasearch from "algoliasearch";
import { useSearch } from "../../hooks/use-search";
import {
  DEFAULT_SEARCH_FLAVOUR_TEXT,
  DEFAULT_SEARCH_FLAVOUR_TITLE,
  DEFAULT_SEARCH_PLACEHOLDER,
  DEFAULT_SEARCH_TITLE,
} from "../../utils/constants";

const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
);

interface SearchHeaderProps {
  __typename?: string;
  title?: string;
  placeholder?: string;
  flavourTitle?: string;
  flavourText?: string;
}

export const SearchHeader = ({
  title,
  placeholder,
  flavourTitle,
  flavourText,
}: SearchHeaderProps): JSX.Element => {
  const { query, showSuggestions, setSearchDescription } = useSearch();
  setSearchDescription(flavourTitle || "", flavourText || "");

  return (
    <Box display="flex" alignItems="flex-end" id="searchHeader">
      <Box flexBasis={["100%", "100%", "660px"]} position="relative">
        <SearchBox
          placeholder={placeholder || DEFAULT_SEARCH_PLACEHOLDER}
          title={title || DEFAULT_SEARCH_TITLE}
        />

        {showSuggestions && (
          <InstantSearch
            indexName={
              process.env.GATSBY_ALGOLIA_OFFERS_QUERY_SUGGESTIONS_INDEX
            }
            searchClient={searchClient}
          >
            <AutoComplete defaultRefinement={query} />
          </InstantSearch>
        )}
      </Box>
      <Box
        marginLeft="40px"
        display={["none", "none", "block"]}
        flexBasis="460px"
      >
        <Description
          heading={flavourTitle || DEFAULT_SEARCH_FLAVOUR_TITLE}
          body={flavourText || DEFAULT_SEARCH_FLAVOUR_TEXT}
        />
      </Box>
    </Box>
  );
};
